import { render, staticRenderFns } from "./RelatedTeaserSection.vue?vue&type=template&id=55d3e0d5&"
import script from "./RelatedTeaserSection.vue?vue&type=script&lang=js&"
export * from "./RelatedTeaserSection.vue?vue&type=script&lang=js&"
import style0 from "./RelatedTeaserSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports